import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Spinner/SpinnerUsage.mdx";

import Examples from "../../Docs/Components/Spinner/SpinnerExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Spinner"
            description="The Spinner shows an asynchronous operation is in progress"
            apiSources={["azure-devops-ui/Components/Spinner/Spinner.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"done"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;